import { css } from '@/styled-system/css';

export const headerRight = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const sectionHeading = css({
  fontSize: 'lg',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: '2x',
});

export const floorPlanImage = css({
  width: '100%',
  height: 'auto',
  display: 'block',
  borderRadius: '8px',
  md: {
    width: '50%',
    marginX: 'auto',
  },
});

export const unitSpecs = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '2x',
  paddingY: '2x',
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const specItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
});

export const specValue = css({
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const sectionDivider = css({
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'hpxGrey400',
  marginY: '3x',
});

export const buildingName = css({
  fontWeight: '700',
  fontSize: 'sm',
  color: 'hpxBlue600',
});

export const buildingAddress = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const propertyLink = css({
  fontSize: 'sm',
  color: 'hpxTeal500',
  fontWeight: '600',
  textDecoration: 'none',
  marginTop: '1x',
  display: 'inline-block',
  _hover: {
    textDecoration: 'underline',
  },
});

export const managerName = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const managerIcon = css({
  width: '16px',
  height: '16px',
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxTeal500',
  marginBottom: '2x',
});

export const verifiedIcon = css({
  width: '16px',
  height: '16px',
});

export const officeHours = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const officeHoursLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const officeHoursLine = css({
  lineHeight: '1.6',
  color: 'hpxBlue500',
});

export const footerActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
});

export const unitSummary = css({});

export const unitSummaryTitle = css({
  fontSize: 'xl',
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const unitSummarySpecs = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const sectionsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});
